export class Person {
    id: number;
    firstname: string;
    lastname: string;
    
    constructor(data) {
        this.id = data.person_pk;
        this.firstname = data.firstname;
        this.lastname = data.lastname;
    }
}
